import { z } from 'zod';
import { createModel } from '../../common';
import {
  dateSchema,
  idSchema,
  phoneSchema,
  quantitySchema,
} from '../../validation';
import { OTPStatusSchema } from './otp.status.model';

/** `OTP db model` */
export const OTPSchema = createModel({
  /** the expiration date of OTP */
  expiredAt: dateSchema,
  /** the code of the OTP such as 12345 */
  code: z.string().trim(),
  /** the status of the OTP such as Sent / verified / etc */
  status: OTPStatusSchema,
  /** the phone number that the OTP has been sent to */
  phone: phoneSchema,
  /** how many tries can OTP be tried until success  */
  tries: quantitySchema.max(3).default(0),
  /** this should be coming from the OTP service provider api such as Unifonic / Twilio */
  messageId: idSchema,
});

/** `OTP db model` */
export type OTP = z.infer<typeof OTPSchema.model>;
export type OTPData = z.infer<typeof OTPSchema.data>;
export type OTPPartial = z.infer<typeof OTPSchema.partial>;
